import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeDialog, removeDialog, closeLastDialogWithBackdrop, closeStructureDialog } from './DialogsActions';
import DialogList from './DialogsList';
import {
  dialogs as dialogsSelector,
  dialogsIds as dialogsIdsSelectors,
  renderBackdrop as renderBackdropSelector,
} from './DialogsSelectors';

const DialogsListContainer = (props) => {
  const { renderBackdrop, dialogsIds, closeDialog, closeLastDialogWithBackdrop, closeStructureDialog, history } = props;

  const handleBodyClass = useCallback(() => {
    if (!renderBackdrop) {
      document.body.classList.remove('dialog-with-backdrop-open');
    } else {
      document.body.classList.add('dialog-with-backdrop-open');
    }
  }, [renderBackdrop]);

  useEffect(() => {
    handleBodyClass();
  }, [renderBackdrop, handleBodyClass]);

  useEffect(() => {
    const escapeHandler = (event) => {
      if (event.keyCode !== 27) {
        return;
      }

      const lastDialogId = dialogsIds.last();

      if (!lastDialogId) {
        return;
      }

      closeDialog({ id: lastDialogId });
    };

    document.addEventListener('keydown', escapeHandler);
    const unlistenHistory = history.listen(() => {
      closeStructureDialog();
    });

    return () => {
      document.removeEventListener('keydown', escapeHandler);
      unlistenHistory();
    };
  }, [dialogsIds, closeDialog, closeStructureDialog, history]);

  const dialogsWrapperOnClick = (e) => {
    const { target } = e;
    const backdropClicked = target.classList.contains('react-dialogs-with-backdrop');

    if (backdropClicked) {
      closeLastDialogWithBackdrop();
    }
  };

  return <DialogList {...props} dialogsWrapperOnClick={dialogsWrapperOnClick} />;
};

const mapStateToProps = (state) => {
  return {
    dialogs: dialogsSelector(state),
    dialogsIds: dialogsIdsSelectors(state),
    renderBackdrop: renderBackdropSelector(state),
  };
};

const mapDispatchToProps = {
  closeDialog,
  removeDialog,
  closeLastDialogWithBackdrop,
  closeStructureDialog,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DialogsListContainer));
